import { InjectionToken } from '@angular/core';
/**
 * NOTE: FIELD_WRAPPER_LISTENER cannot be injected directly in UiFieldWrapper.
 * This is due to dynamic rendering causing the input not to be a member of Content.
 * For this reason, we search for listener inside of InputRef, which has access to component and component providers using constructor injection.
 */
export const FIELD_WRAPPER_LISTENER = /*#__PURE__*/new InjectionToken('field-wrapper-listener');